<form class="pmd-form-card forgotpassword-section"
    *ngIf="!token"
    [formGroup]="loginForm"
    (ngSubmit)="loginSubmit()">
    <pmd-alert type="danger"
        *ngIf="loginErrorMessage">
        {{ loginErrorMessage }}
    </pmd-alert>
    <div class="mb-4">
        <h2 class="card-title">Demo Account</h2>
        <p class="card-subtitle">Please enter the mobile number associated with your account.</p>
    </div>
    <pmd-textfield-outline pmd-floating-label
        [ngClass]="sharedService.pmdStatusClass(f.mobile, isSubmitAttempted)">
        <label for="mobile">Mobile Number <strong class="text-danger">*</strong></label>
        <input id="mobile"
            type="text"
            formControlName="mobile"
            class="form-control"
            [ngClass]="sharedService.statusClass(f.mobile, isSubmitAttempted)"
            pmdTextField
            autofocus>
        <div *ngIf="sharedService.hasErrors(f.mobile, isSubmitAttempted)"
            class="invalid-feedback">
            Please enter a valid mobile number.
        </div>
    </pmd-textfield-outline>
    <div class="">
        <button type="submit"
            [disabled]="loginForm.invalid"
            [attr.aria-disabled]="loginForm.invalid"
            pmdRipple
            pmd-btn-raised
            color="secondary">
            Send Request
        </button>
        <p class="mt-3 mb-3">
            Have account?
            <a routerLink="/login"
                class="link-text">
                Sign In
            </a>
        </p>
    </div>
</form>
<form [formGroup]="otpForm"
    *ngIf="token"
    (ngSubmit)="otpSubmit()">
    <div id="otpFieldscreen">
        <div class="mb-4">
            <h1 class="h2 card-title">Enter 6 digit recovery code</h1>
            <p class="card-subtitle">
                The recovery code has been sent to your mobile number. Please enter the code to verify your account.
            </p>
        </div>
        <pmd-alert type="danger"
            *ngIf="otpErrorMessage">
            {{ otpErrorMessage }}
        </pmd-alert>
        <div class="d-flex gap-3 justify-content-center khr-forgot-pw">
            <pmd-textfield pmd-textfield-outline
                *ngFor="let otp of otpForm.controls; index as i"
                [ngClass]="sharedService.pmdStatusClass(otp, isSubmitAttempted)">
                <input #otp
                    [id]="'count' + i"
                    [ngClass]="sharedService.statusClass(otp, isSubmitAttempted)"
                    [formControlName]="i"
                    maxlength="1"
                    type="text"
                    class="form-control"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)"
                    pmdTextField>
            </pmd-textfield>
        </div>
        <div class="d-flex mt-3"
            [class.disabled-section]="timeMS > 0">
            <p class="mb-0">
                <a href="javascript:void(0);"
                    (click)="loginSubmit();"
                    [class.disabled-link]="timeMS > 0">
                    Resend code
                </a>
            </p>
            <span class="ms-auto">{{ getTime() }}</span>
        </div>
        <div class="mt-4">
            <button pmdRipple
                [disabled]="otpForm.invalid"
                [attr.aria-disabled]="otpForm.invalid"
                type="submit"
                pmd-btn-raised
                color="secondary">
                Sign In Now
            </button>
            <p class="mt-3 mb-0"
                class="link-text mt-3">
                <span [pmdPopover]="popTemplate"
                    container="body"
                    placement="bottom"
                    containerClass="turnOverPopUp pmd-card mb-1"
                    class="py-2">Did not receive the verification code?</span>
            </p>
            <ng-template #popTemplate>
                <div class="verification-code">
                    <div class="title-info">
                        If you have not received a verification code on your mobile number:
                    </div>
                    <ul class="list-group pmd-list mb-3">
                        <li class="list-group-item w-100 d-flex"><span aria-hidden="true"
                                class="material-symbols-outlined me-2 pmd-icon-primary pmd-icon-sm">refresh</span>
                            <span>Try "Resend code" option above.</span>
                        </li>
                        <li class="list-group-item w-100 d-flex"><span aria-hidden="true"
                                class="material-symbols-outlined me-2 pmd-icon-primary pmd-icon-sm">check</span>
                            <span>Please check if you have entered a correct mobile number.</span>
                        </li>
                    </ul>
                    <p>
                        For any further assistance please contact our support team at
                        <a href="mailto:support@kharchaapp.com"
                            target="_blank">
                            [support@purchaseapp.com]
                        </a>.
                    </p>
                </div>
            </ng-template>
        </div>
    </div>
</form>